var mentions_default = {
  "mentionPalette": "LW8G0",
  "mention": "Lt2Cb",
  "mentionViewer": "SiegN",
  "mentionSuggestionsEntry": "pP7LD",
  "mentionSuggestionsEntryFocused": "AdiKJ",
  "mentionSuggestionsEntryText": "zeimg",
  "mentionSuggestionsEntryAvatar": "O0kAx",
  "mentionSuggestions": "_5axN-",
  "cursorDefault": "kcdr4",
  "cursorPointer": "la3Dl"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
